import Flex from "@irati/ui/src/Flex"
import styled, {css} from "styled-components"
import Form from "@irati/ui/src/Form"

export const Image = styled.img`
  height: 140px;
  width: 140px;
  margin-bottom: 15px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
  height: 200px;
  width: 200px;
`}
`
export const Separator = styled.span`
  display: block;
  height: 1px;
  width: 100%;
  ${({theme}) => css`
    background: ${theme.colors.greys.mediumLight};
  `}
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
  width: 1px;
  height: 100%;
  margin-right: 1rem;
`}
`

export const StyledFlex = styled(Flex)`
  flex-direction: column;
  gap: 3rem;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
  flex-direction: row;
  gap: 0;
  padding: ${theme.spacing.three} 0;
`}
`
export const RewardRecognitionContainer = styled(Flex)`
  flex-direction: column;
  background: ${({theme}) => theme.colors.tertiary.y_200};
  border-radius: ${({theme}) => theme.spacing.one};
  padding: ${({theme}) => theme.spacing.two};
`
export const TotalPointsContainer = styled<{borderColor: string}>(Flex)`
  align-items: center;
  height: 48px;
  background: ${({theme}) => theme.colors.greys.light};
  border: 1px solid ${({borderColor}) => borderColor};
  border-left: 0;
  max-width: 60%;
  justify-content: space-between;
  white-space: nowrap;
  gap: ${({theme}) => theme.spacing.one};
  padding: ${({theme}) => `${theme.spacing.oneAndHalf} ${theme.spacing.two}`};
`
export const StyledForm = styled(Form)`
  display: flex;
  width: 100%;
  margin-bottom: ${({theme}) => theme.spacing.one};
  flex-direction: column;
  .form-control {
    margin: 0;
  }
  .form-group {
    flex: 1;
    min-width: 100%;
    ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
      min-width: 0;
    `}
  }
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    flex-direction: row;
    align-items: center;
    gap: ${theme.spacing.half};
  `}
`
export const StyledFlexPointsContainer = styled(Flex)`
  flex-wrap: wrap;
  flex: 1;
  width: 100%;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    width: auto;
  `}
  ${TotalPointsContainer} {
    min-width: 100%;
    ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    min-width: 0;
  `}
  }
`
